import { Box } from '@mui/system';
import { motion } from 'framer-motion';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Typography, useTheme, Button } from '@mui/material';

export default function CheckoutReturn() {
  const theme = useTheme();
  const queryParams = new URLSearchParams(window.location.search);
  const edit = queryParams.get('edit') === 'true';

  const content = {
    title: edit ? 'Änderungen gespeichert!' : 'Zahlung erfolgreich!',
    message: edit
      ? 'Die Änderungen an deinem Abonnement wurden erfolgreich gespeichert und sind jetzt aktiv.'
      : 'Vielen Dank für deinen Einkauf! Deine Zahlung wurde erfolgreich verarbeitet und dein Abonnement ist jetzt aktiv.',
    buttonText: 'Zurück zum Appstore',
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        px: 2,
        position: 'relative',
        overflow: 'hidden',
        flexDirection: 'column',
      }}
    >
      <>
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{
            type: 'spring',
            stiffness: 260,
            damping: 20,
            duration: 0.5,
          }}
        >
          <CheckCircleIcon
            sx={{
              fontSize: 120,
              color: theme.palette.primary.main,
              mb: 3,
            }}
          />
        </motion.div>
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.6 }}
        >
          <Typography variant="h4" align="center" gutterBottom>
            {content.title}
          </Typography>
        </motion.div>
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.6 }}
        >
          <Typography
            variant="body1"
            align="center"
            color="textSecondary"
            sx={{ mb: 4, maxWidth: 500 }}
          >
            {content.message}
          </Typography>
        </motion.div>
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.7, duration: 0.6 }}
        >
          <Button variant="contained" color="primary" href="/apps">
            {content.buttonText}
          </Button>
        </motion.div>
      </>
    </Box>
  );
}
